import { render, staticRenderFns } from "./ChallengeCard.vue?vue&type=template&id=562a2cad&scoped=true"
import script from "./ChallengeCard.vue?vue&type=script&lang=js"
export * from "./ChallengeCard.vue?vue&type=script&lang=js"
import style0 from "./ChallengeCard.vue?vue&type=style&index=0&id=562a2cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a2cad",
  null
  
)

export default component.exports